__turbopack_context__.v({
  "loginLink": "styles-module___4bkdW__loginLink",
  "quizSignupDivider": "styles-module___4bkdW__quizSignupDivider",
  "signupGateContainer": "styles-module___4bkdW__signupGateContainer",
  "signupGateContent": "styles-module___4bkdW__signupGateContent",
});
